import {
  all, call, put, takeLatest, select,
} from 'redux-saga/effects';
import request, { authRequest } from '../../helpers/request.helper';
import { authSuccessAction, authFailureAction } from '../actions/creators/auth.actioncreator';
import { obtenerFiltrosFromDB } from '../actions/creators/pel.actioncreator';

import {
  AUTH_PERMISOS_FAILURE,
  AUTH_PERMISOS_REQUEST, AUTH_PERMISOS_SUCCESS, AUTH_RECOVER_FAILURE, AUTH_RECOVER_REQUEST, AUTH_RECOVER_SUCCESS,
  AUTH_REQUEST,
} from '../actions/constants/auth.constants';
import { GIOTALK_INICIAR_CONEXION_WS } from '../actions/constants/giotalk.constants';
import { valorPermiso } from '../../helpers/auth.helper';
import { NAVIGATION_ENABLE } from '../actions/constants/app.constants';
import {message} from "antd";
import history from '../../history';

const authState = state => state.auth;

function* authorize({ payload: { login, password, dominio } }) {
  const formData = new FormData();
  formData.append('username', login);
  formData.append('password', password);
  formData.append('tenant-dominio', dominio);
  formData.append('mostrar_permisos', true);
  const params = {
    url: 'auth/login',
    method: 'POST',
    body: formData,
  };
  try {
    const { token, user, permisos } = yield call(request, params);
    yield put(authSuccessAction(token, user, permisos));
  } catch (error) {
    yield put(authFailureAction(error));
  }
}

function* obtenerPermisos() {
  try {
    const auth = yield select(authState);
    let { permisos } = auth;
    if (permisos === undefined || permisos === null) {
      const params = {
        url: 'api/permisos',
        method: 'POST',
      };
      const response = yield call(authRequest, params);
      permisos = response.permisos;
    }
    yield put({ type: AUTH_PERMISOS_SUCCESS, payload: { permisos } });
  } catch (ex) {
    yield put({ type: AUTH_PERMISOS_FAILURE });
  }
}

function* recoverPassword({ payload: { email, dominio, locale } }) {
  try {
    const formData = new FormData();
    formData.append('dominio', dominio);
    formData.append('email', email);
    formData.append('locale', locale);
    formData.append('redirect', '');
    const params = {
      url: 'auth/recuperacion/enviar',
      method: 'POST',
      body: formData,
    };
    const response = yield call(request, params);

    message.success('Correo enviado correctamente');
    yield put({ type: AUTH_RECOVER_SUCCESS, payload: response });
    history.push('auth/login');
  } catch (error) {
    message.error(error.data && error.data.error_info ? error.data.error_info.exception_message : error.message);
    yield put({ type: AUTH_RECOVER_FAILURE, payload: error });
  }
}

function* afterPermisosSuccess() {
  try {
    const permisoNotificaciones = yield valorPermiso('acceso_sistema_notificaciones');
    if (permisoNotificaciones === 'S') {
      yield put({ type: GIOTALK_INICIAR_CONEXION_WS });
    }
    yield call(obtenerFiltrosFromDB);
  } catch (ex) {

  }
}

function* authenticationRequest() {
  yield all([
    takeLatest(AUTH_REQUEST, authorize),
    takeLatest(AUTH_PERMISOS_REQUEST, obtenerPermisos),
    takeLatest(AUTH_PERMISOS_SUCCESS, afterPermisosSuccess),
    takeLatest(AUTH_RECOVER_REQUEST, recoverPassword),
  ]);
}

export default authenticationRequest;
